import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

// Enable custom parse format plugin
dayjs.extend(customParseFormat);

export const convertToApiDateFormat = (dateInput: string | Date | number): string => {
  if (!dateInput) {
    throw new Error('Date input is required');
  }

  if (typeof dateInput === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateInput)) {
    return dateInput;
  }

  let parsedDate: dayjs.Dayjs;

  if (typeof dateInput === 'string') {
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateInput)) {
      parsedDate = dayjs(dateInput, 'DD/MM/YYYY', true);
      if (parsedDate.isValid()) {
        return parsedDate.format('YYYY-MM-DD');
      }
    }

    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateInput)) {
      parsedDate = dayjs(dateInput, 'MM/DD/YYYY', true);
      if (parsedDate.isValid()) {
        return parsedDate.format('YYYY-MM-DD');
      }
    }

    const commonFormats = ['YYYY/MM/DD', 'DD-MM-YYYY', 'MM-DD-YYYY', 'YYYY.MM.DD', 'DD.MM.YYYY'];

    for (const format of commonFormats) {
      parsedDate = dayjs(dateInput, format, true);
      if (parsedDate.isValid()) {
        return parsedDate.format('YYYY-MM-DD');
      }
    }

    parsedDate = dayjs(dateInput);
  } else {
    parsedDate = dayjs(dateInput);
  }

  if (!parsedDate.isValid()) {
    throw new Error(`Unable to parse date: ${dateInput}`);
  }

  return parsedDate.format('YYYY-MM-DD');
};

export const convertFromApiDateFormat = (apiDate: string): string => {
  const parsedDate = dayjs(apiDate, 'YYYY-MM-DD', true);

  if (!parsedDate.isValid()) {
    throw new Error(`Invalid API date format: ${apiDate}`);
  }

  return parsedDate.format('DD/MM/YYYY');
};

export const getDateRangeForInterval = (
  interval: string,
  endDate?: Date
): { from: string; to: string } => {
  const end = dayjs(endDate || new Date());
  let start: dayjs.Dayjs;

  switch (interval) {
    case 'daily':
      start = end.subtract(30, 'day');
      break;
    case 'weekly':
      start = end.subtract(12, 'week');
      break;
    case 'monthly':
      start = end.subtract(12, 'month');
      break;
    default:
      start = end.subtract(30, 'day');
  }

  return {
    from: start.format('YYYY-MM-DD'),
    to: end.format('YYYY-MM-DD'),
  };
};

export const isValidDate = (dateString: string): boolean => {
  try {
    convertToApiDateFormat(dateString);
    return true;
  } catch {
    return false;
  }
};
